import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import get from "lodash/get";

const useDisableOn = (disableOn) => {
  const { getValues, watch } = useFormContext();
  const [fieldDisabled, setFieldDisabled] = useState(false);

  useEffect(() => {
    if (!disableOn || !Array.isArray(disableOn)) return;

    setFieldDisabled(
      disableOn.some((item) => getValues(item.field) === item.value),
    );
  }, [getValues, disableOn]);

  useEffect(() => {
    if (!disableOn) return;

    const { unsubscribe } = watch((value, { name, type }) => {
      if (type !== "change") return;

      const entity = disableOn.find((el) => el.field === name);
      if (!entity) return;

      setFieldDisabled(get(value, entity.field) == entity.value);
    });
    return () => unsubscribe();
  }, [watch, disableOn]);

  return fieldDisabled;
};

export default useDisableOn;
